/* =========================================================
   YORUKYO v2 — premium.js
   Drawers, cart drawer (Section Rendering API), quick add,
   predictive search, rail, manifesto scrub, cursor, magnetic,
   header hide-on-scroll, announcement rotation, load more.
   ========================================================= */
(function () {
  'use strict';
  var cfg = window.Yorukyo || {};
  var routes = cfg.routes || {};
  var fx = cfg.effects || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- generic drawers ---------- */
  var openDrawer = null, lastFocus = null;
  function lockScroll(on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
    if (window.YorukyoLenis) on ? window.YorukyoLenis.stop() : window.YorukyoLenis.start();
  }
  function open(el) {
    if (!el) return;
    if (openDrawer && openDrawer !== el) close(openDrawer, true);
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
    lockScroll(true);
    openDrawer = el;
    var focusEl = $('[data-search-input]', el) || $('.drawer__panel, .mobile-menu__panel, .search-overlay__panel', el);
    setTimeout(function () { if (focusEl) focusEl.focus({ preventScroll: true }); }, 60);
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function close(el, quick) {
    if (!el) return;
    el.classList.remove('is-open');
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, quick ? 0 : 600);
    if (openDrawer === el) { openDrawer = null; lockScroll(false); }
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!quick && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); open(document.getElementById(opener.getAttribute('data-drawer-open'))); return; }
    if (t.closest('[data-drawer-close]') || t.closest('[data-menu-close]')) {
      var d = t.closest('[data-drawer], [data-mobile-menu]');
      if (d) close(d);
      return;
    }
    if (t.closest('[data-menu-open]')) { open($('[data-mobile-menu]')); return; }
    if (t.closest('[data-search-open]')) { open($('[data-search]')); return; }
    var cartBtn = t.closest('[data-cart-open]');
    if (cartBtn && $('[data-cart-drawer]') && cfg.cartType !== 'toast' && !document.body.classList.contains('template-cart')) {
      e.preventDefault(); open($('[data-cart-drawer]'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (!openDrawer) return;
    if (e.key === 'Escape') { close(openDrawer); return; }
    if (e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, [tabindex="0"]', openDrawer).filter(function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- cart: add / change / re-render ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    $$('[data-cart-bubble]').forEach(function (el) { el.hidden = !n; });
    var link = $('.cart-link');
    if (link) { link.classList.remove('is-bumped'); void link.offsetWidth; link.classList.add('is-bumped'); }
  }
  function renderDrawer(html) {
    var drawer = $('[data-cart-drawer]');
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawerInner');
    var cur = document.getElementById('CartDrawerInner');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    var c = fresh && fresh.querySelector('.drawer__count');
    if (c) setCount(parseInt(c.textContent, 10) || 0);
  }
  function refreshDrawer() {
    return fetch((routes.root || '/') + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { renderDrawer(d['cart-drawer']); })
      .catch(function () {});
  }
  function addVariant(id, qty, btn) {
    if (btn) btn.classList.add('is-loading');
    var useDrawer = cfg.cartType !== 'toast' && $('[data-cart-drawer]');
    return fetch(routes.cartAdd + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }], sections: useDrawer ? 'cart-drawer' : undefined })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (!res.ok) { alertMsg(res.d.description || res.d.message || 'Could not add that item.'); return; }
        if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1400); }
        if (useDrawer) {
          if (res.d.sections) renderDrawer(res.d.sections['cart-drawer']); else refreshDrawer();
          open($('[data-cart-drawer]'));
        } else {
          window.location.href = routes.cart;
        }
      })
      .catch(function () { if (btn) btn.classList.remove('is-loading'); window.location.href = routes.cart; });
  }
  function alertMsg(msg) {
    var t = $('[data-toast]');
    if (!t) return;
    t.innerHTML = '<p class="toast__title">Heads up</p><div class="toast__row"><span></span></div>';
    t.querySelector('span').textContent = msg;
    t.hidden = false;
    setTimeout(function () { t.hidden = true; }, 4000);
  }
  // product form added (theme.js) → open drawer
  document.addEventListener('yk:cart-added', function () {
    refreshDrawer().then(function () { open($('[data-cart-drawer]')); });
  });
  // quick add + upsells + line quantity
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-qa-id]');
    if (qa) { e.preventDefault(); addVariant(qa.getAttribute('data-qa-id'), 1, qa); return; }
    var ua = e.target.closest('[data-upsell-add]');
    if (ua) { var sel = ua.parentElement.querySelector('[data-upsell-select]'); if (sel) addVariant(sel.value, 1, ua); return; }
    var tog = e.target.closest('[data-qa-toggle]');
    if (tog) { var card = tog.closest('.card'); $$('.card.is-qa-open').forEach(function (c) { if (c !== card) c.classList.remove('is-qa-open'); }); card.classList.toggle('is-qa-open'); return; }
    var lq = e.target.closest('[data-line-qty]');
    if (lq) {
      var line = lq.closest('[data-line]');
      var drawer = $('[data-cart-drawer]');
      drawer.classList.add('is-busy');
      fetch(routes.cartChange + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(line.getAttribute('data-line')), quantity: Number(lq.getAttribute('data-line-qty')), sections: 'cart-drawer' })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d.sections) renderDrawer(d.sections['cart-drawer']); else refreshDrawer(); if (typeof d.item_count === 'number') setCount(d.item_count); })
        .catch(function () { window.location.href = routes.cart; })
        .then(function () { drawer.classList.remove('is-busy'); });
    }
  });

  /* ---------- predictive search ---------- */
  function search() {
    var input = $('[data-search-input]'), out = $('[data-search-results]');
    if (!input || !out) return;
    var t, ctrl;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(function () {
        if (ctrl && ctrl.abort) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = (routes.search || '/search/suggest') + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        fetch(url, { signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var sec = doc.querySelector('.shopify-section') || doc.body;
            out.innerHTML = sec.innerHTML;
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ---------- announcement rotation ---------- */
  function announce() {
    var bar = $('[data-announce]');
    if (!bar) return;
    var msgs = $$('.announcement__msg', bar);
    if (msgs.length < 2 || reduce) return;
    var i = 0, ms = (parseInt(bar.getAttribute('data-interval'), 10) || 4) * 1000;
    setInterval(function () {
      var cur = msgs[i], next = msgs[(i + 1) % msgs.length];
      cur.classList.add('is-leaving'); cur.classList.remove('is-active'); cur.setAttribute('aria-hidden', 'true');
      next.classList.remove('is-leaving'); next.classList.add('is-active'); next.removeAttribute('aria-hidden');
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 650);
      i = (i + 1) % msgs.length;
    }, ms);
  }

  /* ---------- scroll: header hide, progress, marquee skew, scrub, wordmark ---------- */
  function scrollFx() {
    var header = $('[data-header]'), bar = $('[data-scroll-progress]');
    var marquees = $$('.marquee__group');
    var scrub = $('[data-scrub]');
    var words = [];
    if (scrub && !reduce) {
      var html = scrub.innerHTML.split(/<br\s*\/?>/i).map(function (line) {
        return line.trim().split(/\s+/).map(function (w) {
          var hot = /03:14|night|tokyo/i.test(w) ? ' is-hotword' : '';
          return '<span class="w' + hot + '">' + w + '</span>';
        }).join(' ');
      }).join('<br>');
      scrub.innerHTML = html;
      scrub.classList.add('is-split');
      words = $$('.w', scrub);
    }
    var lastY = window.scrollY, lastT = performance.now(), skew = 0, ticking = false;
    function frame() {
      ticking = false;
      var y = window.scrollY, h = document.documentElement.scrollHeight - window.innerHeight;
      if (bar) bar.style.setProperty('--p', h > 0 ? (y / h).toFixed(4) : 0);
      if (header) {
        header.classList.toggle('is-scrolled', y > 10);
        var hide = y > lastY && y > 400 && !openDrawer;
        header.classList.toggle('is-hidden', hide);
      }
      if (!reduce && marquees.length) {
        var v = (y - lastY) / Math.max(16, performance.now() - lastT);
        skew = Math.max(-8, Math.min(8, v * -4));
        marquees.forEach(function (m) { m.style.setProperty('--skew', skew.toFixed(2) + 'deg'); });
        clearTimeout(frame.reset);
        frame.reset = setTimeout(function () { marquees.forEach(function (m) { m.style.setProperty('--skew', '0deg'); }); }, 120);
      }
      if (words.length) {
        var r = scrub.getBoundingClientRect();
        var p = (window.innerHeight * 0.85 - r.top) / (r.height + window.innerHeight * 0.35);
        p = Math.max(0, Math.min(1, p));
        var lit = Math.round(p * words.length);
        words.forEach(function (w, i) { w.classList.toggle('is-lit', i < lit); w.classList.toggle('is-hot', i < lit && w.classList.contains('is-hotword')); });
      }
      lastY = y; lastT = performance.now();
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
    frame();

    var wm = $('[data-wordmark]');
    if (wm && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en, o) { en.forEach(function (x) { if (x.isIntersecting) { wm.classList.add('is-in'); o.disconnect(); } }); }, { threshold: 0.2 }).observe(wm);
    } else if (wm) wm.classList.add('is-in');
  }

  /* ---------- product rail: drag, buttons, progress ---------- */
  function rails() {
    $$('[data-rail]').forEach(function (rail) {
      var vp = $('[data-rail-track]', rail), barEl = $('[data-rail-bar]', rail);
      if (!vp) return;
      function step() { var c = $('.card', vp); return c ? c.getBoundingClientRect().width + 20 : 300; }
      function update() {
        var max = vp.scrollWidth - vp.clientWidth;
        var vis = vp.clientWidth / vp.scrollWidth;
        if (barEl) { barEl.style.setProperty('--p', Math.min(1, vis + (max > 0 ? (vp.scrollLeft / max) * (1 - vis) : 1)).toFixed(3)); }
        var prev = $('[data-rail-prev]', rail), next = $('[data-rail-next]', rail);
        if (prev) prev.disabled = vp.scrollLeft < 4;
        if (next) next.disabled = vp.scrollLeft > max - 4;
      }
      vp.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      var p = $('[data-rail-prev]', rail), n = $('[data-rail-next]', rail);
      if (p) p.addEventListener('click', function () { vp.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { vp.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      if (!fine) return;
      var down = false, sx = 0, sl = 0, moved = false;
      vp.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.target.closest('button')) return; down = true; moved = false; sx = e.clientX; sl = vp.scrollLeft; });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 5) { moved = true; vp.classList.add('is-dragging'); }
        vp.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return; down = false;
        setTimeout(function () { vp.classList.remove('is-dragging'); }, 30);
      });
      vp.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      vp.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) e.stopPropagation();
      }, { passive: true });
    });
  }

  /* ---------- product gallery (mobile dots) + mini gallery ---------- */
  function galleries() {
    $$('[data-gallery]').forEach(function (g) {
      var track = $('[data-gallery-track]', g), dots = $$('[data-gallery-dot]', g), idx = $('[data-gallery-index]', g);
      if (!track || !dots.length) return;
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        if (idx) idx.textContent = i + 1;
      }, { passive: true });
    });
    $$('[data-mini-gallery]').forEach(function (g) {
      var main = $('[data-mini-main]', g);
      if (!main) return;
      $$('[data-mini-thumb]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-mini-thumb]', g).forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          main.classList.add('is-swapping');
          setTimeout(function () {
            main.removeAttribute('srcset');
            main.onload = function () { main.classList.remove('is-swapping'); };
            main.src = b.getAttribute('data-src');
            if (main.complete) main.classList.remove('is-swapping');
          }, 200);
        });
      });
    });
  }

  /* ---------- shop the look ---------- */
  function look() {
    $$('[data-look]').forEach(function (s) {
      function activate(i) {
        $$('[data-hotspot]', s).forEach(function (h) { h.classList.toggle('is-active', h.getAttribute('data-hotspot') === i); });
        $$('[data-look-item]', s).forEach(function (it) { it.classList.toggle('is-active', it.getAttribute('data-look-item') === i); });
      }
      $$('[data-hotspot]', s).forEach(function (h) {
        h.addEventListener('click', function () {
          var i = h.getAttribute('data-hotspot'); activate(i);
          var it = $('[data-look-item="' + i + '"]', s);
          if (it && window.innerWidth < 990) it.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
        h.addEventListener('mouseenter', function () { activate(h.getAttribute('data-hotspot')); });
      });
    });
  }

  /* ---------- recommendations (Section Rendering) ---------- */
  function recs() {
    $$('[data-recs]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.children.length) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recs]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          $$('[data-reveal]', el).forEach(function (n) { n.classList.add('is-in'); });
        }
      }).catch(function () {});
    });
  }

  /* ---------- collection: load more ---------- */
  function loadMore() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-load-more]');
      if (!btn) return;
      e.preventDefault();
      btn.classList.add('is-loading');
      fetch(btn.href).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-load-grid]'), more = $('[data-load-grid]', doc);
        if (grid && more) $$('.card', more).forEach(function (c) { c.classList.add('is-in'); grid.appendChild(c); });
        var wrap = btn.closest('.load-more'), nwrap = $('.load-more', doc);
        if (wrap) { if (nwrap) wrap.innerHTML = nwrap.innerHTML; else wrap.remove(); }
        if (window.history.replaceState) window.history.replaceState({}, '', btn.href);
      }).catch(function () { window.location.href = btn.href; });
    });
  }

  /* ---------- custom cursor ---------- */
  function cursor() {
    var c = $('[data-cursor]');
    if (!c || !fine || reduce || !fx.cursor) return;
    document.documentElement.classList.add('has-cursor');
    var label = $('[data-cursor-label]', c);
    var x = -100, y = -100, cx = x, cy = y;
    window.addEventListener('pointermove', function (e) { x = e.clientX; y = e.clientY; }, { passive: true });
    (function loop() {
      cx += (x - cx) * 0.22; cy += (y - cy) * 0.22;
      c.style.setProperty('--cx', cx.toFixed(1) + 'px'); c.style.setProperty('--cy', cy.toFixed(1) + 'px');
      requestAnimationFrame(loop);
    })();
    document.addEventListener('pointerover', function (e) {
      var t = e.target.closest('[data-cursor-text]');
      var l = e.target.closest('a, button, label, summary, select, input');
      c.classList.toggle('is-label', !!t);
      c.classList.toggle('is-link', !t && !!l);
      if (t) label.textContent = t.getAttribute('data-cursor-text');
    });
    document.addEventListener('pointerdown', function () { c.classList.add('is-down'); });
    document.addEventListener('pointerup', function () { c.classList.remove('is-down'); });
    document.addEventListener('mouseleave', function () { c.classList.add('is-hidden'); });
    document.addEventListener('mouseenter', function () { c.classList.remove('is-hidden'); });
  }

  /* ---------- magnetic buttons + tilt + hero mouse parallax ---------- */
  function magnetic() {
    if (!fine || reduce) return;
    if (fx.magnetic) {
      $$('[data-magnetic]').forEach(function (el) {
        el.addEventListener('pointermove', function (e) {
          var r = el.getBoundingClientRect();
          var dx = (e.clientX - r.left - r.width / 2) / r.width, dy = (e.clientY - r.top - r.height / 2) / r.height;
          el.style.transform = 'translate(' + (dx * 14).toFixed(1) + 'px,' + (dy * 10).toFixed(1) + 'px)';
        });
        el.addEventListener('pointerleave', function () { el.style.transform = ''; });
      });
    }
    $$('[data-tilt]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--ry', (((e.clientX - r.left) / r.width - 0.5) * 6).toFixed(2) + 'deg');
        el.style.setProperty('--rx', (((e.clientY - r.top) / r.height - 0.5) * -6).toFixed(2) + 'deg');
      });
      el.addEventListener('pointerleave', function () { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
    });
    var hero = $('[data-hero]');
    if (hero) {
      var layers = $$('[data-tilt-layer]', hero).filter(function (l) { return !l.classList.contains('js-parallax'); });
      hero.addEventListener('pointermove', function (e) {
        var px = e.clientX / window.innerWidth - 0.5, py = e.clientY / window.innerHeight - 0.5;
        layers.forEach(function (l) {
          var d = parseFloat(l.getAttribute('data-tilt-layer')) || 0;
          l.style.transform = 'translate3d(' + (px * d).toFixed(1) + 'px,' + (py * d).toFixed(1) + 'px,0)';
        });
      });
      layers.forEach(function (l) { l.style.transition = 'transform .8s cubic-bezier(.16,1,.3,1)'; });
    }
  }

  function init() {
    search();
    announce();
    scrollFx();
    rails();
    galleries();
    look();
    recs();
    loadMore();
    cursor();
    magnetic();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
